import { render, staticRenderFns } from "./CreditcardDetailPage.vue?vue&type=template&id=1679c53e&scoped=true&"
import script from "./CreditcardDetailPage.vue?vue&type=script&lang=js&"
export * from "./CreditcardDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CreditcardDetailPage.vue?vue&type=style&index=0&id=1679c53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1679c53e",
  null
  
)

export default component.exports